"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutStateFactoryFromJS = exports.LayoutStateFactory = void 0;
const immutable_1 = require("immutable");
const IToolbar_1 = require("../pluginManager/IToolbar");
const IMenubar_1 = require("../pluginManager/IMenubar");
const IWindow_1 = require("./window/IWindow");
exports.LayoutStateFactory = (0, immutable_1.Record)({
    window: (0, IWindow_1.WindowFactory)(),
    menubar: (0, IMenubar_1.MenubarFactory)(),
    toolbar: (0, IToolbar_1.ToolbarFactory)()
});
const LayoutStateFactoryFromJS = function (data) {
    return (0, exports.LayoutStateFactory)({
        window: (0, IWindow_1.WindowFactoryFromJS)(data.window),
        menubar: (0, IMenubar_1.MenubarFactoryFromJS)(data.menubar),
        toolbar: (0, IToolbar_1.ToolbarFactoryFromJS)(data.toolbar)
    });
};
exports.LayoutStateFactoryFromJS = LayoutStateFactoryFromJS;
//# sourceMappingURL=layout.js.map